export default {
  // Errors
  emailNotConfirmed: 'لطفا قبل از ادامه، ایمیل خود را تایید کنید',
  internalServerError: 'خطای داخلی سرور',
  phoneNumberNotConfirmed: 'لطفا قبل از ادامه، شماره همراه خود را تایید کنید',
  unauthorized: 'اجازه ی انجام این درخواست را ندارید',
  validationFailed: 'خطای اعتبارسنجی',

  // Words
  active: 'فعال',
  add: 'افزودن',
  address: 'آدرس',
  altName: 'نام فرعی',
  appLogo: 'لوگو @:branding.appName',
  approve: 'تایید',
  approved: 'تایید شده',
  areYouSure: 'آیا مطمئن هستید؟',
  areYouSureToRemoveThisItem: 'آیا مطمئن هستید که می خواهید این آیتم را حذف کنید؟',
  attachments: 'پیوست ها',
  autoLocation: 'مکان یابی خودکار',
  availability: 'دسترسی',
  bankAccounts: {
    accountNo: 'شماره حساب',
    accountOrShebaNo: 'شماره حساب / شبا',
    accountOwnerName: 'نام صاحب حساب',
    accountTitle: 'عنوان حساب',
    bankAccounts: 'حساب های بانکی',
    enterBankAccounts: 'نام حساب بانکی را وارد کنید',
    bankName: 'نام بانک',
    branchCode: 'کد شعبه',
    branchName: 'نام شعبه',
    enterBankName: 'نام بانک را وارد کنید',
    shebaNumber: 'شماره شبا'
  },
  basicContractData: 'اطلاعات قرارداد پایه',
  basicFeatures: 'ویژگی های پایه',
  cancel: 'انصراف',
  choose: 'انتخاب کنید',
  code: 'کد',
  color: 'رنگ',
  companyName: 'نام شرکت',
  contactNumber: 'شماره تماس',
  contacts: 'اطلاعات تماس',
  contractExpireDate: 'تاریخ انقضا قرارداد',
  contractNum: 'شماره قرارداد',
  contractScan: 'اسکن قرارداد',
  coordinates: 'موقعیت جغرافیایی',
  count: 'تعداد',
  create: 'افزودن',
  created: 'تاریخ ثبت',
  createSomeCategoriesFirst: 'لطفا ابتدا حداقل یک دسته ایجاد کنید',
  customColor: 'رنگ دلخواه',
  dateAndHour: 'تاریخ و ساعت',
  deactive: 'غیر فعال',
  description: 'توضیحات',
  details: 'جزئیات',
  disapprove: 'رد کردن',
  disapproved: 'رد شده',
  documents: {
    documentAttachments: 'فایل های پیوست مدرک {document}',
    documentName: 'نام مدرک {document}',
    documents: 'مدارک',

    // System document types
    BirthCertificate: 'شناسنامه',
    BusinessLicense: 'جواز کسب',
    LatestChangesAd: 'آگهی آخرین تغییرات',
    NationalCard: 'کارت ملی',
    OfficialNewspaper: 'روزنامه رسمی',
    RegistrationAd: 'آگهی ثبت',
    Statute: 'اساسنامه',
    ValueAddedRegistrationCertificate: 'گواهی ثبت نام ارزش افزوده'
  },
  duplicateItem: '{title} تکراری',
  economicalCode: 'کد اقتصادی',
  edit: 'ویرایش',
  email: 'ایمیل',
  expireDate: 'تاریخ پایان اعتبار',
  fatherName: 'نام پدر',
  featured: 'برگزیده',
  fieldTypes: {
    personal: 'شخصی',
    personalPhoneNumber: 'تلفن همراه شخصی',
    personalTelephoneNumber: 'تلفن ثابت شخصی',
    work: 'کاری',
    workPhoneNumber: 'تلفن همراه کاری',
    workTelephoneNumber: 'تلفن ثابت کاری'
  },
  filling: 'در حال تکمیل',
  headerImage: 'تصویر سربرگ',
  hour: 'ساعت',
  icon: 'آیکون',
  id: 'شناسه',
  identityData: 'اطلاعات هویتی',
  image: 'تصویر',
  individual: 'حقیقی',
  insertUnderContract: 'درج در زیر قرارداد',
  invalidItem: '{title} نامعتبر',
  lastDayOfExpireDate: 'آخرین روز تاریخ پایان اعتبار {title}',
  legal: 'حقوقی',
  logo: 'لوگو',
  enterUserName: 'نام کاربر را وارد کنید',
  minutes: 'دقیقه',
  name: 'نام',
  nationalId: 'شناسه ملی',
  no: 'خیر',
  noMatchingRecords: 'هیچ رکوردی منطبق با جستجوی شما یافت نشد',
  noRecords: 'رکوردی برای نمایش وجود ندارد',
  notApproved: 'تایید نشده',
  notes: 'یادداشت ها',
  oneReqiured: 'حداقل یکی از موارد {fields} الزامی است',
  oopsWeHaveAProblem: "مشکلی پیش آمده!",
  oopsYouAreLost: 'مسیر را اشتباه رفته اید!',
  or: 'یا',
  otherNames: 'دیگر نام ها',
  pageDescription: 'توضیحات صفحه',
  pageDescriptionForSeo: 'توضیحات صفحه برای سئو',
  pageTitle: 'عنوان صفحه',
  passedExpireDate: 'یک روز از تاریخ پایان اعتبار {title} گذشته است | {count} روز از تاریخ پایان اعتبار {title} گذشته است',
  password: 'رمز عبور',
  passwordConfirm: 'تکرار رمز عبور',
  pending: 'در انتظار تایید',
  person: 'شخص',
  phoneNumber: 'شماره همراه',
  position: 'سمت',
  precision: 'تعداد ارقام اعشاری',
  primaryCategory: 'دسته اصلی',
  print: 'پرینت',
  publish: 'انتشار',
  publishDate: 'تاریخ انتشار',
  redirect: 'Permanent Redirect URL 301',
  regDate: 'تاریخ ثبت',
  regNum: 'شماره ثبت',
  relatedCategories: 'دسته های مرتبط',
  remove: 'حذف',
  return: 'بازگشت',
  save: 'ذخیره',
  saveAndReviewRequest: 'ذخیره و درخواست بررسی',
  seal: 'تصویر مهر',
  search: 'جستجو',
  select: 'انتخاب',
  selectedColor: 'رنگ انتخابی',
  seoFeatures: 'ویژگی های سئو',
  settings: 'تنظیمات',
  showsInBrowserTab: 'در Tab مرورگر نمایش داده میشود',
  signatorCertification: 'گواهی امضا',
  signatories: 'صاحبان امضا',
  signatureImage: 'تصویر امضا',
  slug: 'Slug',
  sortOrder: 'ترتیب',
  status: 'وضعیت',
  statusUpdated: 'وضعیت به روز رسانی شد',
  submitedDate: 'تاریخ ثبت',
  systemMessage: 'پیام سیستم',
  tag: 'تگ',
  tags: 'تگ ها',
  text: 'متن',
  thePageYouAreLookingForIsTemporaryUnavailable: "صفحه مورد نظر شما موفقتا در دسترس نیست.",
  thePageYouAreLookingForWasNotFound: 'صفحه مورد نظر شما وجود ندارد.',
  tillExpireDate: 'یک روز تا تاریخ پایان اعتبار {title} | {count} روز تا تاریخ پایان اعتبار {title}',
  title: 'عنوان',
  type: 'نوع',
  to: 'تا',
  url: 'آدرس پیوند',
  user: 'کاربر',
  userData: 'اطلاعات کاربری',
  view: 'نمایش',
  viewData: 'داده ها',
  website: 'وب سایت',
  yes: 'بله',
  youAreOffline: 'به نظر می آید ارتباط شما با سرویس دهنده برقرار نیست.',
  youHave: 'شما'
}
